// extracted by mini-css-extract-plugin
module.exports = {"input":"_4e5f713ae4--input--Fok74","postfix":"_4e5f713ae4--postfix--Aoved"};